module.exports = "<span class=\"fa {{ legendInfo.icon }}\"></span>\n<div class=\"text\">\n    {{ legendInfo.message }}\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/coverage-modal/coverage-legend-item.component.html
// module id = 1082
// module chunks = 1